export const MAX_MARKDOWN_SOURCE_BYTES = 256 * 1024
export const MAX_MARKDOWN_PREVIEW_BYTES = 64 * 1024

export class MarkdownSourceLimitError extends Error {
  constructor() {
    super(`Markdown source exceeds ${MAX_MARKDOWN_SOURCE_BYTES} UTF-8 bytes`)
    this.name = 'MarkdownSourceLimitError'
  }
}

export class MarkdownPreviewLimitError extends Error {
  constructor() {
    super(`Markdown preview exceeds ${MAX_MARKDOWN_PREVIEW_BYTES} UTF-8 bytes`)
    this.name = 'MarkdownPreviewLimitError'
  }
}
